module.exports = {
  "id": "door",
  "title": "door",
  "image": "provision/parts/door/door.png",
  "info": [
    {
      "text": "Add a door to your project",
      "image": "provision/parts/door/door.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/door/door.png"
} ;